import React from "react";
import { ApolloError } from "@apollo/client";
import { Modal } from "antd";
import { CloseCircleFilled } from "@ant-design/icons";
import Icons from "components/icons";

const errorNotification = (error: ApolloError) =>
{
    if (error.graphQLErrors !== undefined) {
        Modal.error({
            className: "modal-standard modal-form",
            centered: true,
            width: 500,
            closeIcon: <Icons.Close />,
            maskClosable: true,
            title: (
                <span className="modal-title">
                    <div className="text">
                        <span
                            style={{
                                color: "var(--switch_colorTextQuaternary)",
                                marginRight: "10px",
                            }}
                        >
                            <CloseCircleFilled />
                        </span>
                        IError
                    </div>
                </span>
            ),
            content: error.graphQLErrors.map(
                ({ message: label, extensions: { reason } }) => (
                    <div key={label} className="error-item">
                        <p>{label}</p>
                        <p>{reason as string}</p>
                    </div>
                )
            ),
        });
    }

    const customError = error as unknown as { reason?: string; label?: string };

    if (customError.reason !== undefined && customError.label !== undefined) {
        Modal.error({
            className: "modal-standard modal-form",
            centered: true,
            width: 500,
            closeIcon: <Icons.Close />,
            maskClosable: true,
            title: (
                <span className="modal-title">
                    <div className="text">
                        <span
                            style={{
                                color: "var(--switch_colorTextQuaternary)",
                                marginRight: "10px",
                            }}
                        >
                            <CloseCircleFilled />
                        </span>
                        IError
                    </div>
                </span>
            ),
            content: (
                <div className="error-item">
                    <p>{customError.label}</p>
                    <p>{customError.reason}</p>
                </div>
            ),
        });
    }

    return null;
};

export default errorNotification;